import React, { Component } from "react"
import SwiperCore, { Mousewheel, Keyboard } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import "swiper/swiper.scss"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { gsap } from "gsap"
import constants from "../constants"
import Actions from "../actions"
import Store from "../store"

SwiperCore.use([Mousewheel, Keyboard])

class GalleryCollection extends Component {
  constructor(props) {
    super(props)
    this.wrapper = React.createRef()
    this.swiper = React.createRef()
    this.controlledSwiper = undefined
    this.activeIndex = 0
    this.allSlides = undefined
    this.activeBlock = undefined
    this.state = {
      version: undefined,
      items: []
    }
  }
  componentDidMount() {
    const version = window.innerWidth < constants.breakpoints.lg ? constants.MOBILE : constants.DESKTOP
    this.setState({
      version: version,
      items: this.props.items
    })
  }
  componentDidUpdate() {
    if (this.props.transition === `out`) {
      gsap.to(this.activeBlock, { scale: 1, duration: 0.8,  ease: `expo.in` })
      gsap.to(this.wrapper.current, { x: `100%`, duration: 0.8, delay: 0.2,  ease: `expo.in` })
    }
    if (this.props.transition === `in`) {
      this.activeIndex = 0
      this.allSlides = [...this.swiper.current.children[0].children]
      setTimeout(Actions.changeSlide, 0, this.activeIndex)
      setTimeout(this.animateSlides, 1000)
    }
  }
  animateSlides = () => {
    if (!this.wrapper.current) return
    if (this.state.version === constants.MOBILE ) return
    const w = window.innerWidth
    const h = window.innerHeight
    const scale = (( h / this.wrapper.current.offsetHeight ) * 1) + 0.1
    const itemW = (w / 5)
    const bigItemW = itemW * scale
    const remainW = bigItemW - itemW
    const slidesIndex = this.activeIndex + 2
    const current = this.allSlides[slidesIndex]
    this.activeBlock = current
    const previous = this.allSlides.slice(0, slidesIndex)
    const after = this.allSlides.slice(slidesIndex + 1, this.allSlides.length)
    gsap.to(current, { scale: scale, x: 0, duration: 0.4, ease: `expo.inout`, zIndex: 30 })
    gsap.to(previous, { x: -remainW/2, scale: 1, duration: 0.4, ease: `expo.inout`, zIndex: 0 })
    gsap.to(after, { x: remainW/2, scale: 1, duration: 0.4, ease: `expo.inout`, zIndex: 0 })
  }
  onSlideChange = (e) => {
    this.activeIndex = e.activeIndex
    this.allSlides = e.slides
    setTimeout(Actions.changeSlide, 0, this.activeIndex)
    this.animateSlides()
  }
  onClickImage = () => {
    if (Store.productLink) window.open(Store.productLink, '_blank').focus()
  }
  render() {
    const slideParentClassName = `w-full relative z-10 h-full lg:h-auto`
    return (
      <button style={{ outline: 0 }} className={`${this.props.className} focus:outline-none ${this.state.version === constants.MOBILE ? `bg-white` : `bg-transparent`}`}>
        <div ref={this.wrapper} className={`relative`}>
          <div className={`w-full relative h-screen lg:h-full flex flex-col justify-center`}>
            <Swiper
              ref={this.swiper}
              spaceBetween={0}
              slidesPerView={this.state.version === constants.MOBILE ? 1 : 5}
              grabCursor={true}
              mousewheel={true}
              keyboard={true}
              onSlideChangeTransitionEnd={this.onSlideChange}
            >
              { this.state.version !== constants.MOBILE && <SwiperSlide className={slideParentClassName}></SwiperSlide> }
              { this.state.version !== constants.MOBILE && <SwiperSlide className={slideParentClassName}></SwiperSlide> }
              {
                this.state.items.map(item => {
                  return (
                    <SwiperSlide key={`${item.id}-video-slideshow`} data-id={item.id} style={{ cursor: `pointer` }} className={`${slideParentClassName}`}>
                      <div onClick={this.onClickImage} style={{ outline: 0 }} className={`w-full h-full lg:h-auto`}>
                        <GatsbyImage
                          className={`w-full h-full`}
                          image={getImage(item.imgSrc.childImageSharp)}
                          alt={item.id}
                        />
                      </div>
                    </SwiperSlide>
                  )
                })
              }
              { this.state.version !== constants.MOBILE && <SwiperSlide className={slideParentClassName}></SwiperSlide> }
              { this.state.version !== constants.MOBILE && <SwiperSlide className={slideParentClassName}></SwiperSlide> }
            </Swiper>
          </div>
        </div>
      </button>
    )
  }
}

export default GalleryCollection